<div class="row align-items-center justify-content-center px-4 px-md-0 h-100">
    <div class="col-12 col-md-3">
        <div class="text-center mb-4">
            <div class="fw-light lh-1">Bem vindo ao</div>
            <h1 class="fw-light">Ariel Manager</h1>
        </div>
        <form name="form" (ngSubmit)="f.form.valid && onSubmit(f)" #f="ngForm" novalidate>
            <div class="mb-3">
                <input type="text" class="form-control form-control-lg" id="username" name="username"
                    [ngClass]="{ 'is-invalid': f.submitted && username.invalid }" #username="ngModel"
                    placeholder="Usuário" ngModel required>
                <div *ngIf="f.submitted && username.invalid" class="invalid-feedback">
                    <div *ngIf="username.errors && username.errors['required']">Usuário é obrigatório</div>
                </div>
            </div>
            <div class="mb-3">
                <input type="password" class="form-control form-control-lg" id="password" name="password"
                    [ngClass]="{ 'is-invalid': f.submitted && password.invalid }" #password="ngModel"
                    placeholder="Senha" ngModel required />
                <div *ngIf="f.submitted && password.invalid" class="invalid-feedback">
                    <div *ngIf="password.errors && password.errors['required']">Senha é obrigatória</div>
                </div>
            </div>
            <button class="btn btn-primary btn-lg w-100" type="submit" [disabled]="f.form.invalid || loading">
                <div class="spinner-border spinner-border-sm" role="status" *ngIf="loading"></div>
                <span *ngIf="!loading">Entrar</span>
            </button>
            <a class="btn btn-sm btn-link btn-lg w-100 mt-2" [routerLink]="['/recover-password']">
                Esqueceu sua senha?
            </a>
            <a class="btn btn-sm btn-link btn-lg w-100 mt-2" [routerLink]="['/privacy-policy']">
                Politicas de Privacidade
            </a>
        </form>
    </div>
</div>
